import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage22.module.css";

export default function LaymanPage22() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>FORCES OF THE SUN</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.om_block_main}>
                <div
                  className={`${styles.om_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/force_of_the_sun/sun_1img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/force_of_the_sun/sun_1img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>The Solar Pulse:</b> Exploring the Occult Forces of
                        the Sun in <Link href="https://www.divineinfinitebeing.com/">the School of Divine Infinite Being</Link> method
                        and Archetypal Astrology.
                      </p>
                      <p>
                        In the intricate dance of cosmic energies, the Sun
                        emerges as a central planetary force, its essence woven
                        into the fabric of the School method and Archetypal
                        Astrology. Beyond the clichés of the vast expanse or
                        spiritual tapestry, the Sun, in its core, represents
                        Solar Consciousness—an awareness that extends from the
                        proximal axis of our individual being to the unified and
                        holistic beauty of Apollo conducting the celestial music of the Spheres. 
                      </p>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Symbolic Essence of OM:</h2>
                      </div> */}
                      <p>
                        At the heart of this exploration lies the understanding
                        that the Sun is not merely a celestial body casting its
                        rays upon the Earth; rather, it is the embodiment of
                        both conscious and transpersonal selves, whirling
                        through the vast universe of personal experience. It
                        serves as a binding force, connecting us to the origin
                        of our species as children of the sun and, quantumly
                        entangled, to the very inception of the Universe.
                      </p>
                      <p>
                        In the realm of Archetypal Astrology, the Sun holds the
                        enigmatic power of the Fool, a secret force that guides
                        us through the maze of existence. It is the concentrated
                        will of the Theurgist, transmitting a cosmic energy that
                        resonates with the very core of our being, both
                        transpersonal and immanent in its perpetual rise.
                      </p>
                      <p>
                        The Sun, as an Archetypal instinct, embodies the concept
                        of the <span><i>"Emerging Spirit"</i></span> and an impulse
                        towards <span><i>"Stabilized Harmony (TAO)."</i></span> It is
                        not merely a ball of fire in the sky but a force that
                        beckons us to synchronize with the rhythmic pulse of the
                        universe. This solar force, akin to the conductor
                        orchestrating a symphony, invites us to harmonize with
                        the Archetypal Cosmos.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/force_of_the_sun/sun_2img.webp"
                    /> */}
                     <img className={styles.orphic_egg_img1} src={`${process.env.cloud_url}Layman-Symbolism/force_of_the_sun/sun_2img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Vibration and Chanting:</h2>
                      </div> */}
                      <p>
                        Embedded within the Sun's radiance is the call to
                        embrace our solar natures. It invites us to acknowledge
                        the profound unity that exists within our collective
                        consciousness, urging us to transcend the boundaries of
                        individuality. In this unified field, the Sun becomes a
                        guiding force, reminding us of our shared origins and
                        entanglements with the cosmic dance.
                      </p>

                      <p>
                        The Sun, as Solar Consciousness, encourages us to delve
                        into the depths of our being, recognizing the threads
                        that connect us to the very beginning of the Universe.
                        In the intricate tapestry of existence, the Sun emerges
                        not only as a source of light but as a beacon guiding us
                        towards self-awareness, unity, and harmony within the
                        Archetypal Cosmos.
                      </p>
                      <p>
                        In conclusion, the forces of the Sun extend far beyond
                        the mere illumination of our world. They are the threads
                        that weave through the cosmic tapestry of our existence,
                        connecting us to the archetypal realms and beckoning us
                        to dance in harmony with the music of the Spheres. The
                        Solar Consciousness, with its transcendent power,
                        invites us to embrace the enigmatic forces of the Sun
                        and to embark on a journey towards self-discovery and
                        cosmic unity.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/force_of_the_sun/sun_3img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/force_of_the_sun/sun_3img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <p>
                        <b>Solar Consciousness:</b> The Sun represents a form of
                        consciousness that transcends individual awareness,
                        symbolizing a higher level of understanding and
                        connection to the cosmos.
                      </p>

                      <p>
                        <b> Central Planetary Force:</b> In astrological terms,
                        the Sun serves as a central planetary force, exerting a
                        significant influence on the individual's character,
                        vitality, and life path.
                      </p>
                      <p>
                        <b> Archetypal Astrology:</b> The Sun plays a pivotal
                        role in Archetypal Astrology, where it is viewed as the
                        proximal axis of our being, unifying both conscious and
                        transpersonal selves.
                      </p>
                      <p>
                        <b>Children of the Sun:</b> Astrologically, the Sun is
                        associated with the concept of being{" "}
                        <span><i>"children of the sun,"</i></span> emphasizing a shared
                        origin and connection to the celestial forces that shape
                        our existence.
                      </p>
                      <p>
                        <b>Quantum Entanglement:</b> The Sun is seen as a
                        quantum entanglement point, linking individuals to the
                        very beginning of the Universe and illustrating the
                        interconnectedness of all life.
                      </p>
                      <p>
                        <b>Fool:</b> The Sun embodies the enigmatic force of the
                        Fool in Archetypal Astrology, guiding individuals
                        through the twists and turns of life's journey.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/force_of_the_sun/sun_4img.webp"
                    /> */}
                      <img className={styles.orphic_egg_img1} src={`${process.env.cloud_url}Layman-Symbolism/force_of_the_sun/sun_4img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Theurgist:</b> The concentrated will of the Theurgist
                        is transmitted through the solar forces, suggesting a
                        cosmic energy that aligns with the core of our being and
                        influences our path.
                      </p>

                      <p>
                        <b>Emerging Spirit:</b> As an Archetypal instinct, the
                        Sun represents the <i>"Emerging Spirit,"</i> signifying a
                        continuous process of growth, self-discovery, and
                        evolution.
                      </p>
                      <p>
                        <b>Harmony (TAO):</b> The Sun's influence is linked to
                        the impulse towards <i>"Stabilized Harmony (TAO)," </i>
                        encouraging individuals to synchronize with the cosmic
                        rhythms and find balance in their lives.
                      </p>
                      <p>
                        <b>Unified Field:</b> The Sun invites us to recognize
                        the unified field of consciousness, where individual
                        boundaries dissolve, and a sense of collective unity
                        prevails.
                      </p>
                      <p>
                        <b>Guiding Force:</b> Astrologically, the Sun serves as
                        a guiding force, directing individuals towards
                        self-awareness, unity, and harmony within the larger
                        context of the Archetypal Cosmos.
                      </p>
                      <p>
                        <b>Symphony of Life:</b> Analogous to a conductor
                        orchestrating a symphony, the Sun encourages individuals
                        to harmonize with the celestial music of the Spheres,
                        embracing the interconnected dance of existence.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* =========================================greensec---------------------------------------------               */}

            <div className={styles.green_sec_cmn_main_wrp}>
              <div className={styles.common_width}>
                <Link href="/rota-the-wheel">
                  <div className={styles.green_sec_cmn_sub_wrp}>
                    <h1>
                      The Astrological Tarot association for the Sun <br /> is
                      Sun See our alchemical ROTA here
                    </h1>
                  </div>
                </Link>
              </div>
            </div>
            {/* ---------------------------------------------------greensec_end=================================== */}
            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_sun/layman_page22_block1_demo_img_nw_ds.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_sun/layman_page22_block2_demo_img_nw_ds.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_sun/layman_page22_block3_demo_img_nw_ds.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_sun/layman_page22_block4_demo_img_nw_ds.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_sun/layman_page22_block5_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
